import { useMemo } from 'react';
import { useEgClickstream } from '@shared-ui/clickstream-analytics-context';
import {
  ApiExplorerActionModel,
  CommonEventProperties,
  events,
  FeedbackIntentModel,
  FeedbackReasonModel,
  SearchInputtedModel,
} from './events';
import useNavigationParams from '../useNavigationParams';
import { useBexApi } from '@shared-ui/bex-api-context';
import { useLocation } from 'react-router-dom';

const useAnalytics = () => {
  const { documentId, hubId, pageName } = useNavigationParams();
  const { context } = useBexApi();
  const { pathname } = useLocation();
  const commonEventProperties: CommonEventProperties = useMemo(() => {
    return {
      pageName,
      hubId,
      locale: context.locale,
      article: { documentId: `/${documentId === '' ? hubId : documentId}`, articleLink: pathname },
    };
  }, [documentId]);
  const track = useEgClickstream();

  return {
    trackPageView: () => {
      track(events.pageViewed(commonEventProperties));
    },
    trackFeedbackIntent: (feedback: FeedbackIntentModel) =>
      track(events.feedbackIntentAdded(feedback, commonEventProperties)),
    trackFeedbackReason: (feedback: FeedbackReasonModel) =>
      track(events.feedbackReasonAdded(feedback, commonEventProperties)),
    trackSearchInput: (search: SearchInputtedModel) => track(events.searchInputted(search, commonEventProperties)),
    trackApiExplorerEndpointExpand: (action: ApiExplorerActionModel) =>
      track(events.apiExplorerEndpointExpanded(action, commonEventProperties)),
    trackApiExplorerRequestButtonClick: (action: ApiExplorerActionModel) =>
      track(events.apiExplorerRequestButtonClick(action, commonEventProperties)),
    trackLinkSelected: (id: string) => track(events.linkSelected(id, commonEventProperties)),
    trackSignInSelected: () => track(events.signInSelected(commonEventProperties)),
    trackSignOutSubmitted: () => track(events.signOutSubmitted(commonEventProperties)),
  };
};
export default useAnalytics;
